// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditorToolsColumn-module__navigationContainer--mWPNh {
    position: absolute;
    rotate: -90deg;
}

.EditorToolsColumn-module__navigation--ROAsX {
    width: max-content;
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateY(1px);
}
`, "",{"version":3,"sources":["webpack://./src/dom/Editor/EditorToolsColumn.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,0BAA0B;AAC9B","sourcesContent":[".navigationContainer {\n    position: absolute;\n    rotate: -90deg;\n}\n\n.navigation {\n    width: max-content;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform: translateY(1px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationContainer": `EditorToolsColumn-module__navigationContainer--mWPNh`,
	"navigation": `EditorToolsColumn-module__navigation--ROAsX`
};
export default ___CSS_LOADER_EXPORT___;
